import PageModel from '@/models/pageModel';

export class SubscriptionTypes extends PageModel {
    static moduleName = 'subscriptionTypes';
    static moduleEntityName = 'subscriptionTypeEntity';
    static listTitle = 'Типы подписок';
    static createTitle = 'Добавление нового типа подписки';
    static editTitle = 'Изменение данных о типе подписки';
    static apiPrefix = 'subscription-types';
}